import React from 'react';
import { Plus } from 'lucide-react';

const AddTabButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="py-2 px-4 text-sm font-medium text-secondary hover:text-secondaryDark transition-colors flex items-center"
    >
      <Plus size={16} className="mr-1" />
    </button>
  );
};

export default AddTabButton;
